/**
 * Modern Annotation System Types
 * Following W3C Web Annotation Data Model principles
 */

export type AnnotationStyle = "highlight" | "underline";

export type AnnotationColor = "yellow" | "green" | "blue" | "pink";

/**
 * Serialized range using CSS selector + text position
 * More stable than DOM paths across page changes
 */
export interface AnnotationTarget {
  /** CSS selector for the container element */
  selector: string;
  /** Text content for verification */
  quote: string;
  /** Character offset from container start */
  startOffset: number;
  /** Character offset from container end */
  endOffset: number;
}

/**
 * Core annotation data structure
 */
export interface Annotation {
  id: string;
  style: AnnotationStyle;
  color: AnnotationColor;
  target: AnnotationTarget;
  note?: string;
  tags?: string[];
  created: number;
  updated: number;
  /** Page URL where annotation exists */
  pageUrl: string;
}

/**
 * Annotation with DOM references (runtime only, not serialized)
 */
export interface AnnotationWithRefs extends Annotation {
  /** DOM elements that represent this annotation */
  elements: HTMLElement[];
}

/**
 * Color configuration
 */
export interface ColorConfig {
  name: string;
  highlight: string;
  underline: string;
  strikethrough: string;
}

export const COLORS: Record<AnnotationColor, ColorConfig> = {
  yellow: {
    name: "Yellow",
    highlight: "rgba(255, 235, 59, 0.4)",
    underline: "#fbc02d",
    strikethrough: "#fbc02d",
  },
  green: {
    name: "Green",
    highlight: "rgba(102, 187, 106, 0.4)",
    underline: "#43a047",
    strikethrough: "#43a047",
  },
  blue: {
    name: "Blue",
    highlight: "rgba(66, 165, 245, 0.4)",
    underline: "#1e88e5",
    strikethrough: "#1e88e5",
  },
  pink: {
    name: "Pink",
    highlight: "rgba(240, 98, 146, 0.4)",
    underline: "#e91e63",
    strikethrough: "#e91e63",
  },
};
